import { useSelector } from "react-redux";

import { AppState } from "../redux/store";
import { ModulesState } from "../redux/module-slice";
import { useEffect, useState } from "react";


/**
 * Tracks whether the module corresponding to the current URL has been loaded.
 * @returns True once the module is present in the loaded modules list.
 */
export function useModuleLoaded() {

    const _moduleState = useSelector<AppState>(state => state.modules) as ModulesState;
    const [_isLoaded, setIsLoaded] = useState<boolean>(false)

    useEffect(() => {
        let loaded = _isLoaded
        let modules = _moduleState.modules;
        if (!loaded && modules.length > 0) {
            let location = window.location.pathname;
            let locationParts = location.split("/")
            let path = `/${locationParts[1]}`
            let module = modules.find(x => x.path === path)
            if (module) {
                loaded = _moduleState.loadedModules.includes(module.id)
            }
            setIsLoaded(loaded);
        }

    }, [_moduleState.loadedModules])

    return _isLoaded;
}